import React from 'react'
import { t } from 'ttag'

import { DeleteResourceModal } from 'components/modals/common/DeleteResourceModal/DeleteResourceModal'

export const DeleteUserModal = ({
  onCancel,
  onClose,
  onConfirm,
  userName,
  isOpen,
}) => (
  <DeleteResourceModal
    alert={t`You are deleting a user.`}
    message={t`Are you sure you want to delete ${userName}?`}
    title={t`Delete user`}
    {...{ onCancel, onClose, onConfirm, isOpen }}
  />
)
